// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"272":"7b0811a3888a796b97d6","558":"d0e2b623c3be3f43ddc7","718":"f80f1a1eca299399e3a6","777":"d071d0bcafafc80a7337"}[chunkId] + ".js";
};